import { Dispatch, SetStateAction, createContext, useState } from "react";
import { IUser } from "../../types/user"

interface IUserContext {
    user: IUser | null;
    setUser: Dispatch<SetStateAction<IUser | null>>;
}

export const UserContext = createContext<IUserContext>(null!);

export const UserProvider = ({ children } : { children: JSX.Element }) => {

    const [user, setUser] = useState<IUser | null>(null);

    return (
        <UserContext.Provider value={{ user, setUser }}>
            {children}
        </UserContext.Provider>
    );

}